import Network from '../network.js'

export default {
  list(request) {
    return Network.get('/notifications', request, true)
  },
  setReadState({ id, isRead }) {
    return Network.patch(
      `/notifications/${id}/read`,
      {
        isRead
      },
      true
    )
  },
  clear({ id }) {
    return Network.patch(`/notifications/${id}/clear`, {}, true)
  },
  markAllAsRead() {
    return Network.patch('/notifications/read-all', {}, true)
  },
  clearAllRead() {
    return Network.patch('/notifications/clear-all', {}, true)
  },
  getMeta() {
    return Network.get('/notifications/meta', null, true)
  }
}
